import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import * as Sentry from "@sentry/browser"
import sendUsAMessageAction from "cc-frontend/lib/actions/app-state/KB_SEND_US_A_MESSAGE"
import type Dispatcher from "cc-frontend/services/dispatcher"
import { first, isNil, map, take, truncate } from "lodash-es"
import { tracked } from "tracked-built-ins"

interface Signature {
  Element: HTMLDivElement
  Args: {}
}
export default class KbSearchContactUs extends Component<Signature> {
  @service declare dispatcher: Dispatcher

  @service declare algolia
  @service declare router

  @tracked selected = null
  @tracked searchTerm = ""
  @tracked hits: Array<any> = []

  get hasEnteredSearchTerm() {
    return !isNil(this.searchTerm) && this.searchTerm !== ""
  }

  @action
  searchAlgolia(searchQuery) {
    let term = truncate(searchQuery, { length: 511 })
    this.searchTerm = term
    if (term === "") {
      this.hits = []
      return
    }
    return this.algolia.help
      .search(term)
      .then(function (data) {
        return map(take(data.hits, 5), (hit: any) => {
          return {
            id: hit.id,
            attributes: {
              title: hit._highlightResult.attributes.title.value,
            },
          }
        })
      })
      .then((hits) => {
        // set(this, 'hasHits', hits && hits.length > 0)
        this.hits = hits
        return hits
      })
      .catch(function (err) {
        console.error(err)
        Sentry.withScope((scope) => {
          scope.setLevel(Sentry.Severity.Error)
          scope.setExtra("error", err)
          Sentry.captureMessage("Algolia search error")
        })
      })
  }

  @action
  selectArticle(matches) {
    let match: { id: string } | undefined = first(matches)
    if (match) this.router.transitionTo("help.article", match.id)
  }

  @action
  sendUsAMessage() {
    this.dispatcher.dispatchPreparedAction(
      sendUsAMessageAction({
        searchQuery: this.searchTerm,
        locationOfAction: "contact_us_page",
      })
    )
    if (window && window.Intercom) {
      window.Intercom("showNewMessage", this.searchTerm)
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Kb::Search::ContactUs": typeof KbSearchContactUs
  }
}
